import type { Portfolio } from 'venn-api';
import { isNil, keyBy, mergeWith } from 'lodash';

export const mergePortfolios = (portfolios: (Portfolio | undefined | null)[]): Portfolio[] => {
  const children = portfolios
    .filter((p) => !isNil(p))
    .map((p) => p.children)
    .map((p) => keyBy(p, 'name'));
  const output = {};
  children.forEach((child) =>
    mergeWith(output, child, (c1, c2) => ({
      ...c2,
      allocation: (c1?.allocation ?? 0) + (c2?.allocation ?? 0),
      children: mergePortfolios([c1, c2]),
    })),
  );
  return Object.values(output);
};
